import { SIZE } from '@app/constants'
import { SEPARATOR } from '@app/constants/separator'

import type { LntSelectProps } from '@app/components/base/Select/types'

export const commonSelectProps: LntSelectProps = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle,
  strictValue: true,
  tokenSeparators: [SEPARATOR.newline]
}
